import React, { Component } from 'react';
import './ConfirmData.css';
import logoblue from '../../../image/logoblue.png'
import { Link } from 'react-router-dom';
import Navbar from '../Components/Navbar/Navbar'
import  smartphone  from '../../../image/smartphone.svg'
import { LinkAPI } from '../../../API/API'
import HandleRes from '../Components/HandleRes/HandleRes';
import axios from 'axios'

class ConfirmPhone extends Component {
    constructor(props) {
        super(props);
        this.state = {
            code: "",
            codeError: "",
            Verifycode:false,
            sendcode:false,
            res_sendcodedone:false,
            networkError: false,
            errordataCodemessage: false,
            errordatamessageCodetext: '',
            hasError: false,
        }
    }


    handleChange = event => {
        const isCheckbox = event.target.type === "checkbox";
        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value
        });
    };
    validatephone = () => {
        let phoneError = "";
      
      
        if ( isNaN(this.state.phone)||this.state.phone.length < 10 ||this.state.phone.length > 11 ) {
            phoneError = "رقم هاتف خطاء";
        }
        
        if (phoneError) {
            this.setState({ phoneError });
            return false;
        }
        return true;
    };
    validate = () => {
        let codeError = "";

        if (this.state.code.length !== 4 || isNaN(this.state.code)) {
            codeError = "اكتب الرمز صحيح";
        }
        if (codeError) {
            this.setState({ codeError });
            return false;
        }
        return true;
    };
    resendcode=()=>{
        const Token =localStorage.getItem("userTokentConfirmData")
        axios.put(`${LinkAPI}/api/businessowner/resendcode`,{},{
            headers:{
              Authorization:`${Token}`,
              lang:"ar",
              confirm:true
            }
          }).then(res =>{
            this.setState({
               sendcode:true,
               res_sendcodedone:true,

              })
              setTimeout(() => {
                this.setState({
                    res_sendcodedone:false
                })
        }, 2000);
              }).catch(error=>{
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                }  else if (error.response.data.message) {
                    this.setState({
                        errordatamessage: true,
                        errordatamessagetext: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
              })
    }
    
    sendphone = event => {
        event.preventDefault();
        const { phone} = this.state
        const Token = localStorage.getItem("userTokentConfirmData")
        const isValid = this.validatephone();
        if (isValid) {

            axios.put(`${LinkAPI}/api/businessowner/sendcode`,{ phone:20+phone.replace(/^0+/, '')},{
                headers:{
                  Authorization:`${Token}`,
                  lang:"ar",
                }
              }
              ).then(res =>{
                this.setState({
                    Verifycode  : true
                })
                }).catch(error=>{
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                }  else if (error.response.data.message) {
                    this.setState({
                        codeError: "",
                        errordataCodemessage: true,
                        errordatamessageCodetext: error.response.data.message,
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
                })
                    }
    };
    handleSubmit = event => {
        event.preventDefault();
        const { code ,phone} = this.state
        const Token = localStorage.getItem("userTokentConfirmData")
        const isValid = this.validate();
        if (isValid) {

            axios.post(`${LinkAPI}/api/businessowner/confirmphone`,{phone:20+phone.replace(/^0+/, ''),code:code},{
                headers:{
                  Authorization:`${Token}`,
                  lang:"ar"
                }
              }
              ).then(res =>{
                localStorage.setItem("userToken", res.data.token)
                localStorage.setItem("KaynuserName", res.data.businessOwner.name)
                window.location.replace("/AR/orders");
                }).catch(error=>{
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                }  else if (error.response.data.message) {
                    this.setState({
                        codeError: "",
                        errordataCodemessage: true,
                        errordatamessageCodetext: error.response.data.message,
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
                })
                    }
    };
    render() {
        document.title ="kayn | تاكيد رقم الهاتف  ";
      document.getElementsByTagName("META")[1].content="كاين | تاكيد رقم الهاتف    ";
      document.documentElement.lang = 'ar';
        return (
            <div className="AppAR ConfirmData">
                <Navbar />
                <div className='container'>
                    
                        <div className="Sign  row">
                            
                            <div className="col-md-6 form text-center   ">
                                <form className="" onSubmit={this.handleSubmit}>
                                  
                                        
                                    {(!this.state.Verifycode?
                                     <div className="px-lg-5 textconfirm">
                                       <div className="form-group my-4  nocounter">
                                       <img className="my-3 warningimg" src={smartphone} alt="smartphone" /><br/> 
                                       <label className="text-muted fontsize9 py-3">اكتب رقم الهاتف</label>

                                            <div className="relative">
                                            <span className="codephone">+20</span>
                                            <input type="number" className={"form-control badge-pill pl-5 p-3 " + (this.state.phoneError ? 'is-invalid' : '')} placeholder="phone" name="phone" value={this.state.phone} onChange={this.handleChange} required/>
                                            </div>
                                            <div style={{ fontSize: 12, color: "red" }}>
                                                {this.state.phoneError}
                                            </div>
                                        </div>
                                        <button  onClick={this.sendphone} className="btn badge-pill p-2 pl-1 px-3 my-4 border shadow btn-primary" >تاكيد</button>

                                    </div>
                                    :  <div className="">
                                        <div className=" px-lg-5 textconfirm nocounter">
                                        <img className="mt-2 warningimg" src={smartphone} alt="smartphone" /><br/>
                                            <label className="text-muted fontsize9 py-3">قم بتاكيد رقم الهاتف</label>
                                            <input type="text" className={"form-control badge-pill p-3 " + (this.state.codeError ? 'is-invalid' : '')} placeholder="ادخل الرمز الذي تم ارساله لرقم الهاتف " name="code" onChange={this.handleChange} value={this.state.code} />
                                        </div>
                                        <div style={{ fontSize: 12, color: "red", }}>
                                            {this.state.codeError}
                                        </div>
                                        {(this.state.errordataCodemessage ?
                                            <div className="p-2" style={{ fontSize: 12, color: "red" }}>
                                                {this.state.errordatamessageCodetext}
                                            </div> : '')}
                                            {this.state.sendcode?'':<p className="pointer fontsize11 text-muted py-1 my-1" onClick={this.resendcode}>ارسال الرمز مره اخري؟</p>}
                                            <button type="submit" className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow btn-primary" >تاكيد</button>

                                    </div>)}
                                </form>
                            </div>
                            <div className="logoform col-6 d-flex align-content-end flex-wrap">
                                <div className="col-12 text-center mt-auto p-2 bd-highlight"><Link to="/AR/"><img className="logo" src={logoblue} alt="kayn" /></Link>       </div>
                                <p className="fontsize2 text-center mb-5 col-12">طلبك الخاصة بك ... طريقك</p>
                            </div>
                        </div> 
                </div>
                {(this.state.res_sendcodedone ? <HandleRes title="تم ارسال الرساله" stylecss="alert-success" /> : '')}
                {(this.state.errordataCodemessage ? <HandleRes title={this.state.errordatamessageCodetext} stylecss="alert-danger" /> : '')}

                {(this.state.networkError ? <HandleRes title="تاكد باتصالك بالانترنت ثم عاود المحاوله" stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="  هناك مشكلة في طلبك" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default ConfirmPhone;